import * as coreCommon from 'assets/core/js/common'
import consentMode from 'assets/core/js/module/consent-mode'
import design from './design'
import footer from './footer'
import header from './header'
import type { DataLayer } from 'assets/core/js/module/data-layer'
// import webvitals from 'assets/core/js/webvitals'

export default {
  preInit: function () {
    if (window.pageDataLayer && window.coreGtmId && window.pageDataLayer[window.coreGtmId]) {
      coreCommon.initAxeptio(window.pageDataLayer[window.coreGtmId] as DataLayer[])
    }
    // webvitals()
  },

  init: function () {
    void (async () => {
      await coreCommon.yieldToMain()
      await coreCommon.loadIconsFont()
    })()
    coreCommon.initLinks()
    header.initMenus()
    footer()
    design.init()
    consentMode.init()

    document.addEventListener('submit', function (e) {
      const target = e.target as HTMLElement

      if (target.classList.contains('prevent-double-submission')) {
        const alreadySubmitted = target.getAttribute('data-already-submitted')

        if (!alreadySubmitted) {
          target.setAttribute('data-already-submitted', '1')
          target.querySelectorAll('button[type=submit]').forEach(function (el) {
            el.classList.add('dca-button--disabled')
          })

          return true
        }

        return false
      }
    })

    window.onpopstate = function (e: PopStateEvent) {
      const target = e.target as Window

      const state = e.state as {
        forceRefresh: boolean
      }

      if (state?.forceRefresh) {
        window.location.href = target.location.href
      }
    }

    document.addEventListener('click', function (e) {
      const target = e.target as HTMLElement

      if (target.matches('.properties__labels-number[data-toggle="1"]')) {
        e.stopPropagation()
        // @ts-expect-error no real errors
        target.parentNode.parentNode.classList.add('labels--all')
      }
    })
  },

  isMobile: function () {
    const mediaQuery = coreCommon.queryMedia('mobile')

    if (mediaQuery) {
      return mediaQuery.matches
    }

    return false
  },

  isTablet: function () {
    const mediaQuery = coreCommon.queryMedia('tablet')

    if (mediaQuery) {
      return mediaQuery.matches
    }

    return false
  },

  getMediaQuerySize: function (size: string) {
    return coreCommon.getMediaQuerySize(size)
  },

  queryMedia: function (size: string) {
    return coreCommon.queryMedia(size)
  },
}
